import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { UserContext } from './App';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Pagenate, PagenateData } from './parts/Pagenate';
import * as URI from 'urijs';
import { SpinnerView } from './parts/SpinnerView';
import UserService, { UserItem } from '#/services/UserService';
import { PAGE_SIZE } from '#/config/constant';
import { FilterView } from './parts/FilterView';

function User() {
  const ctx = useContext(UserContext);
  const service = new UserService(ctx.userInfo!);
  const uri = new URI.default(window.location.href);
  const [page, setPage] = useState<PagenateData>({
    total: 0,
    page: Number(uri.query(true)['page'] || 0),
    size: PAGE_SIZE,
  });
  const [users, setUsers] = useState<UserItem[]>();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!ctx.userInfo) {
      return;
    }

    let group = 'user';
    switch (ctx.userInfo.role) {
      case 'admin':
        group = ctx.userInfo.id;
        break;

      case 'user':
        group = ctx.userInfo.admin_id;
        break;
    }

    setUsers(undefined);

    service
      .getList({
        ...page,
        ...uri.query(true),
        group,
      })
      .then((res) => {
        setPage({
          ...page,
          ...res.page,
        });
        setUsers(res.data);
      }, (e) => {
        if( e?.response.status === 401 ) {
          navigate(0);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  let items = [<></>];
  if (users === undefined) {
    items = [
      <tr key="spinner">
        <td colSpan={8}>
          <SpinnerView />
        </td>
      </tr>,
    ];
  } else if (users.length > 0) {
    items = users.map((data) => {
      const notify = [
        data.notify.sms_verifier ? 'SMS' : '',
        data.notify.email_verifier ? 'Mail' : '',
      ];

      return (
        <tr key={data.id}>
          <td>
            <Link to={`/user/${data.id}`}>{data.id}</Link>
          </td>
          <td>{data.name}</td>
          <td>{data.device_count.owner}</td>
          <td>{notify.join(' / ')}</td>
          <td>{data.payment_plan}</td>
        </tr>
      );
    });
  } else {
    items = [
      <tr key="no-data">
        <td colSpan={8}>データがありません</td>
      </tr>,
    ];
  }

  const addButton =
    ctx.userInfo && ctx.userInfo!.role === 'admin' ? (
      <Col className="text-end">
        <Button variant="primary" className="w-50" href="/user/add">
          登録
        </Button>
      </Col>
    ) : (
      <></>
    );

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <FilterView id={true} name={true} />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Pagenate {...page} />
              </Col>
              {addButton}
            </Row>
            <Row className="mt-3 border">
              <Col className="p-2">
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th>ユーザID</th>
                      <th>名称</th>
                      <th>子機数</th>
                      <th>お知らせ設定</th>
                      <th>課金プラン</th>
                    </tr>
                  </thead>
                  <tbody>{items}</tbody>
                </Table>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default User;
